import jQuery from "jquery";
import featherlight from "featherlight";
declare function featherlight(jquery: JQueryStatic): void;
featherlight(jQuery);
